import React from 'react';
import { MarketplaceContent } from '../../marketplace/Marketplace';
import './MarketplaceSection.css';

export default function DashboardMarketplaceSection() {
  return (
    <div className="dashboard-marketplace-section">
      <MarketplaceContent withinDashboard />
    </div>
  );
}
